import { render, staticRenderFns } from "./CtaNav.vue?vue&type=template&id=81fc48b0&scoped=true&"
import script from "./CtaNav.vue?vue&type=script&lang=js&"
export * from "./CtaNav.vue?vue&type=script&lang=js&"
import style0 from "./CtaNav.vue?vue&type=style&index=0&id=81fc48b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fc48b0",
  null
  
)

export default component.exports